"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var CategoryMenuLoader_1 = __importDefault(require("../category/CategoryMenuLoader"));
var NavBarItem_1 = __importDefault(require("./NavBarItem"));
var ui_1 = require("@aperza/ui");
var PromoteCompanyLink_1 = __importDefault(require("./PromoteCompanyLink"));
var SignUpLink_1 = __importDefault(require("./SignUpLink"));
var util_1 = require("@aperza/util");
var graphql_tag_1 = __importDefault(require("graphql-tag"));
var appConfig = util_1.AppService.appConfig();
var NavBar = function (props) {
    var viewer = props.viewer, disableNavCategory = props.disableNavCategory, disableNavCatalog = props.disableNavCatalog, disableNavMarketplace = props.disableNavMarketplace, disableNavNews = props.disableNavNews, disableNavExhibitions = props.disableNavExhibitions, disableNavManufacturers = props.disableNavManufacturers, disableNavShops = props.disableNavShops, disableNavPromote = props.disableNavPromote, disableNavRegisterAccount = props.disableNavRegisterAccount;
    var style = {
    //position: 'absolute',
    //left: this.state.left,
    };
    var refParent = react_1.useRef(null);
    var ref = react_1.useRef(null);
    var _a = react_1.useState(0), left = _a[0], setLeft = _a[1];
    return (react_1.default.createElement("div", { ref: refParent, className: "strip aw-navbar", style: {
            justifyContent: 'space-between',
            position: 'relative',
            height: '18px',
        } },
        react_1.default.createElement("div", { ref: ref, className: "strip", style: style },
            !disableNavCategory && viewer && !appConfig.hideProductCategory && (react_1.default.createElement(ui_1.WebMediaQuery, { desktopOnly: true },
                react_1.default.createElement(CategoryMenuLoader_1.default, __assign({}, props)))),
            !disableNavCatalog && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(NavBarItem_1.default, { title: react_1.default.createElement(ui_1.Message, { messageId: "navbar.searchCatalog" }), shortTitle: react_1.default.createElement(ui_1.Message, { messageId: "navbar.searchCatalog_short" }), icon: "catalog", url: appConfig.searchWebUrlPrefix + "/catalog/" }))),
            !disableNavMarketplace && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(NavBarItem_1.default, { title: react_1.default.createElement(ui_1.Message, { messageId: "navbar.buy" }), shortTitle: react_1.default.createElement(ui_1.Message, { messageId: "navbar.buy_short" }), icon: "cart", url: "https://www" + appConfig.baseComDomain + "/marketplace/index.html" }))),
            !disableNavNews && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(NavBarItem_1.default, { title: react_1.default.createElement(ui_1.Message, { messageId: "navbar.news" }), shortTitle: react_1.default.createElement(ui_1.Message, { messageId: "navbar.news_short" }), icon: "news", openOnNewTab: true, url: "https://news" + appConfig.baseDomain }))),
            !disableNavExhibitions && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(NavBarItem_1.default, { title: react_1.default.createElement(ui_1.Message, { messageId: "navbar.exhibitions" }), shortTitle: react_1.default.createElement(ui_1.Message, { messageId: "navbar.exhibitions_short" }), icon: "building", url: appConfig.searchWebUrlPrefix + "/feature/top" }))),
            !disableNavManufacturers && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(NavBarItem_1.default, { title: react_1.default.createElement(ui_1.Message, { messageId: "navbar.ec.manufacturers" }), url: appConfig.marketplaceWebUrlPrefix + "/mfr/index.html" }))),
            !disableNavShops && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(NavBarItem_1.default, { title: react_1.default.createElement(ui_1.Message, { messageId: "navbar.ec.shops" }), url: appConfig.searchWebUrlPrefix + "/dst/mp/index.html" })))),
        react_1.default.createElement("div", { className: "strip right " },
            !disableNavPromote && viewer && !viewer.isLogin && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(PromoteCompanyLink_1.default, __assign({}, props)))),
            !disableNavRegisterAccount && viewer && !viewer.isLogin && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(SignUpLink_1.default, __assign({}, props)))),
            !disableNavPromote &&
                viewer &&
                viewer.isLogin &&
                [1, 2, 3].includes(viewer.endUserType) && react_1.default.createElement(PromoteCompanyLink_1.default, null))));
};
NavBar.propTypes = {
    viewer: prop_types_1.default.shape({
        id: prop_types_1.default.string,
        isLogin: prop_types_1.default.bool,
        endUserType: prop_types_1.default.number,
    }),
    disableNavCategory: prop_types_1.default.bool,
    disableNavCatalog: prop_types_1.default.bool,
    disableNavMarketplace: prop_types_1.default.bool,
    disableNavNews: prop_types_1.default.bool,
    disableNavExhibitions: prop_types_1.default.bool,
    disableNavManufacturers: prop_types_1.default.bool,
    disableNavShops: prop_types_1.default.bool,
    disableNavPromote: prop_types_1.default.bool,
    disableNavRegisterAccount: prop_types_1.default.bool,
    disableMarketplaceBanner: prop_types_1.default.bool,
};
NavBar.fragments = {
    viewer: graphql_tag_1.default(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    fragment NavBar_viewer on Viewer {\n      id\n      isLogin\n      endUserType\n    }\n  "], ["\n    fragment NavBar_viewer on Viewer {\n      id\n      isLogin\n      endUserType\n    }\n  "]))),
};
exports.default = NavBar;
var templateObject_1;
